<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { handleNext } from '../tutorialSteps'
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import { useGameStore } from '@/stores/gameStore.ts'
import { useAssetStore } from '@/stores/assetStore.ts'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const playerFlagsStore = usePlayerFlagsStore()
const gameStore = useGameStore()
const assetStore = useAssetStore()

const planetType = computed(() => {
  const planetTypeId = gameStore.player?.homeWorldPlanetType
  if (planetTypeId) {
    const planetTypeData = assetStore.findPlanetTypeById(planetTypeId)
    return planetTypeData?.name || 'Temperate'
  }
  return 'Temperate'
})

const handleNextStep = async () => {
  await handleNext('tutorial_terraforming_end')
  await playerFlagsStore.setFlag('tutorial_complete', 'true')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.terraformingEnd.excellent') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.terraformingEnd.notTooMany') }}
      </p>
      <p class="pb-2">
        <i18n-t keypath="tutorial.terraformingEnd.convertTo" tag="span">
          <template #planetType><span class="text-green-500">{{ planetType }}</span></template>
        </i18n-t>
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info">
        {{ t('tutorial.terraformingEnd.gravityPenalty') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.terraformingEnd.gotItThankYou') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>